import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

class Form extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    error: PropTypes.string
  };

  renderField = data => {
    data.input.className = 'form-control';

    const isInvalid = data.meta.touched && !!data.meta.error;
    if (isInvalid) {
      data.input.className += ' is-invalid';
      data.input['aria-invalid'] = true;
    }

    if (this.props.error && data.meta.touched && !data.meta.error) {
      data.input.className += ' is-valid';
    }

    return (
      <div className={`form-group`}>
        <label
          htmlFor={`usedprocedurestep_${data.input.name}`}
          className="form-control-label"
        >
          {data.input.name}
        </label>
        <input
          {...data.input}
          type={data.type}
          step={data.step}
          required={data.required}
          placeholder={data.placeholder}
          id={`usedprocedurestep_${data.input.name}`}
        />
        {isInvalid && <div className="invalid-feedback">{data.meta.error}</div>}
      </div>
    );
  };

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          component={this.renderField}
          name="usedProcedure"
          type="text"
          placeholder=""
        />
        <Field
          component={this.renderField}
          name="procedureStep"
          type="text"
          placeholder=""
        />
        <Field
          component={this.renderField}
          name="isCompleted"
          type="checkbox"
          placeholder=""
        />
        <Field
          component={this.renderField}
          name="completedAt"
          type="dateTime"
          placeholder=""
        />
        <Field
          component={this.renderField}
          name="createdBy"
          type="text"
          placeholder=""
        />
        <Field
          component={this.renderField}
          name="updatedBy"
          type="text"
          placeholder=""
        />
        <Field
          component={this.renderField}
          name="position"
          type="number"
          placeholder=""
        />
        <Field
          component={this.renderField}
          name="createdAt"
          type="dateTime"
          placeholder=""
        />
        <Field
          component={this.renderField}
          name="updatedAt"
          type="dateTime"
          placeholder=""
        />

        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </form>
    );
  }
}

export default reduxForm({
  form: 'usedprocedurestep',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(Form);
